import PropTypes from "prop-types";
import { useState } from "react";
import { useAlert } from "react-alert";
import { useIntl } from "react-intl";
import SimpleModalCompact from "../../common/ModalCompact/SimpleModalCompact";
import AccountSettingsViewSelector from "./AccountSettingsViewSelector";

const AccountSettingsModal = ({ handleClose, initialValues = {}, onSaved, open }) => {
  const intl = useIntl();
  const alert = useAlert();

  const [accountSettings, setAccountSettings] = useState(initialValues);

  const { firstname, lastname } = accountSettings;

  const contactInfoText = intl.formatMessage({ id: "account.contactInformation" });

  const headerText = () => {
    let title = "";

    if (firstname) {
      title = `${firstname}`;
      if (lastname) {
        title = `${firstname} ${lastname}`;
      }
      title = `${title} - ${contactInfoText}`;
    } else if (lastname) {
      title = `${lastname} - ${contactInfoText}`;
    } else {
      title = `${contactInfoText}`;
    }
    return title;
  };

  return (
    <SimpleModalCompact open={open} onClose={handleClose} title={headerText()}>
      <AccountSettingsViewSelector
        accountSettings={accountSettings}
        onError={() => {
          alert.error(
            intl.formatMessage({ id: "userAccount.errors.genericError" })
          );
          handleClose?.();
        }}
        onSaved={onSaved}
        setAccountSettings={setAccountSettings}
      />
    </SimpleModalCompact>
  );
};

AccountSettingsModal.propTypes = {
  handleClose: PropTypes.func,
  initialValues: PropTypes.shape({
    contact: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
  }).isRequired,
  onSaved: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default AccountSettingsModal;
